import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { IndianRupee, Wallet, Users, BookOpen, Star, Gauge } from "lucide-react";

const glow = "absolute -top-10 -right-10 w-32 h-32 rounded-full blur-3xl opacity-20";

function StatCard({ icon: Icon, label, value, prefix, suffix, color, delay, testId, emptyState }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay }}
      className="relative overflow-hidden rounded-2xl border border-white/[0.08] bg-[#131a29]/80 backdrop-blur-xl p-5 shadow-[0_8px_32px_rgba(0,0,0,0.12)]"
      data-testid={testId}
    >
      <div className={glow} style={{ background: color }} />
      <div className="relative flex items-center justify-between">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: `${color}1a` }}>
          <Icon className="w-4.5 h-4.5" style={{ color }} />
        </div>
      </div>
      {emptyState ? (
        <p className="relative text-xs text-slate-500 mt-4">Awaiting Data</p>
      ) : (
        <p className="relative font-heading text-2xl font-semibold text-[#f7f8f8] mt-4 tracking-tight">
          {prefix}<CountUp end={value} duration={1.1} separator="," decimals={suffix === "★" ? 1 : 0} />{suffix}
        </p>
      )}
      <p className="relative text-xs text-[#8a8f98] mt-1">{label}</p>
    </motion.div>
  );
}

export default function CreatorHeroStats({ profile, analytics }) {
  const a = analytics || {};
  return (
    <div data-testid="creator-hero-stats">
      <motion.div initial={{ opacity: 0, y: -8 }} animate={{ opacity: 1, y: 0 }} className="mb-5">
        <h1 className="font-heading text-3xl sm:text-4xl font-semibold tracking-tight text-[#f7f8f8]" data-testid="creator-welcome-heading">
          Welcome back, <span className="bg-gradient-to-r from-[#3B82F6] to-[#A855F7] bg-clip-text text-transparent">{(profile.name || profile.creator_handle || "Creator").split(" ")[0]}</span>
        </h1>
        <p className="text-sm text-[#8a8f98] mt-1.5">Here's how @{profile.creator_handle} is performing today.</p>
      </motion.div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <StatCard testId="stat-today-revenue" icon={IndianRupee} label="Today's Revenue" value={a.today_revenue || 0} prefix="₹" color="#3B82F6" delay={0} />
        <StatCard testId="stat-month-revenue" icon={Wallet} label="Monthly Revenue" value={a.month_revenue || 0} prefix="₹" color="#A855F7" delay={0.05} />
        <StatCard testId="stat-total-students" icon={Users} label="Total Learners" value={a.total_learners || 0} color="#34D399" delay={0.1} />
        <StatCard testId="stat-active-courses" icon={BookOpen} label="Active Courses" value={a.active_courses || 0} color="#FBBF24" delay={0.15} />
        <StatCard testId="stat-course-rating" icon={Star} label="Course Rating" value={a.course_rating} suffix={a.course_rating != null ? "★" : ""} emptyState={a.course_rating == null} color="#F472B6" delay={0.2} />
        <StatCard testId="stat-completion-rate" icon={Gauge} label="Completion Rate" value={a.completion_rate} suffix={a.completion_rate != null ? "%" : ""} emptyState={a.completion_rate == null} color="#22D3EE" delay={0.25} />
      </div>
    </div>
  );
}
